// extracted by mini-css-extract-plugin
export default {"container":"Balance_container__3fLqu","text":"Balance_text__PwyZi","balance":"Balance_balance__wWerM"};